import { Link } from 'react-router-dom';
import React from 'react';

export const NotFoundPage = () => (
    <div className="homePageContainer">
      404 - <Link to="/">Go home</Link>
    </div>
  );